import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import { NotificationProvider } from "../../context/NotificationContext";
import { SnackAlertContext } from "../../context/SnackAlertContext";
import { useContext } from "react";
import SnackAlert from "../../components/SnackAlert";
import TopNav from "./Nav/TopNav";

const ShopAccountDashboard = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    openSnackAlert,
    setOpenSnackAlert,
    snackAlertSeverity,
    snackAlertTitle,
    snackAlertMessage,
  } = useContext(SnackAlertContext);

  return (
    <>
      <NotificationProvider>
        {/* {isSmallScreen ? (
          <Box>
            <BottomNav />
          </Box>
        ) : (
          <Box>
            <TopNav />
          </Box>
        )} */}

        <Box>
          <TopNav />
        </Box>
      </NotificationProvider>
      <SnackAlert
        open={openSnackAlert}
        setOpen={setOpenSnackAlert}
        severity={snackAlertSeverity}
        title={snackAlertTitle}
        message={snackAlertMessage}
      />
    </>
  );
};
export default ShopAccountDashboard;
